<template>
  <div class="h-screen w-screen flex flex-col pt-safe-flush px-safe-flush pb-safe">
    <div class="flex grow items-center justify-center">
      <div class="update-rocket-wrapper">
        <span class="update-rocket">🚀</span>
      </div>
    </div>

    <div class="mt-auto p-5">
      <div class="text-center p-2">
        <h1 class="uppercase text-sm text-gray-700">{{ t('update.available') }}</h1>
        <h2 class="text-xl font-bold my-2">{{ t('update.please_update') }}
        </h2>
        <p class="text-sm text-gray-700 font-light">{{ t('update.description') }}
        </p>
      </div>

      <Divider class="my-5" />

      <PrimaryButton
        class="w-full h-16 flex items-center uppercase tracking-wide text-xl font-normal bg-apex-purple-500"
        @click="handleUpdate">{{ t('update.button') }}</PrimaryButton>
    </div>
  </div>
</template>
<script setup lang="ts">
import { AppUpdate } from '@capawesome/capacitor-app-update';
import { useI18n } from 'vue-i18n';
import { useAppSettingsStore } from '../stores/AppSettingsStore';
import PrimaryButton from '../components/buttons/PrimaryButton.vue';
import Divider from '../components/Divider.vue';
const { t } = useI18n();
const appSettingsStore = useAppSettingsStore();

const handleUpdate = async () => {
  // Redirect the user to the update page

  if (appSettingsStore.plateform === 'android' && appSettingsStore.updateInfo?.immediateUpdateAllowed) {
    await AppUpdate.performImmediateUpdate();
    return;
  }

  // In any other case, redirect the user to the store
  await AppUpdate.openAppStore();
}
</script>

<style scoped>
.update-rocket-wrapper {
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.update-rocket {
  font-size: 96px;
  animation: rocketBob 2.5s ease-in-out infinite;
}
@keyframes rocketBob {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-14px); }
}
</style>